import { Component, OnInit } from '@angular/core';
import { IElement } from 'dbweb-core';
import { RouteElementService } from 'dbweb-core';

@Component({
	selector: 'common-page-not-found',
	templateUrl: './page-not-found.component.html',
	styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {
	element: IElement;
	constructor(private rele: RouteElementService) {}

	ngOnInit() {
		this.rele.currentElement.subscribe(ele => (this.element = ele.element));
	}
}
